module.exports = __webpack_public_path__ + "static/assets/a68f59fe7551dc8c7b9e8162e4ccbeaa.svg";